import { combineReducers } from 'redux';
import {
    RECEIVE_PAYMENTREQUEST_ONGOING,
    REQUEST_PAYMENTREQUEST_ONGOING,
    FAILURE_PAYMENTREQUEST_ONGOING
} from './constants';
import { RESET_ACCOUNT_USER } from '../../constants';

/*
 * State shape
{
    ongoing : {},
    fetching: false,
    error: ''
}
*/

const ongoing = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_PAYMENTREQUEST_ONGOING:
            return action.response.payload;
        case RESET_ACCOUNT_USER:
            return {};
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PAYMENTREQUEST_ONGOING:
            return true;
        case FAILURE_PAYMENTREQUEST_ONGOING:
        case RECEIVE_PAYMENTREQUEST_ONGOING:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_PAYMENTREQUEST_ONGOING:
            return action.response.message;
        case REQUEST_PAYMENTREQUEST_ONGOING:
        case RECEIVE_PAYMENTREQUEST_ONGOING:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    ongoing,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/ongoing/reducer.js